import { render } from "./CVExperience.vue?vue&type=template&id=27b0a38a&scoped=true"
import script from "./CVExperience.vue?vue&type=script&lang=js"
export * from "./CVExperience.vue?vue&type=script&lang=js"

import "./CVExperience.vue?vue&type=style&index=0&id=27b0a38a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b0a38a"]])

export default __exports__